<mat-form-field class="field" [formGroup]="group" appearance="outline">
  <mat-label>{{ config.label }}</mat-label>
  <input
    matInput
    [formControlName]="config.name"
    [matDatepicker]="picker"
    placeholder="{{ config.label }}"
  />
  <mat-datepicker-toggle matSuffix [for]="picker"> </mat-datepicker-toggle>
  <mat-datepicker #picker> </mat-datepicker>
</mat-form-field>
